import React from "react";
import Col from "react-bootstrap/Col";

/**
 * TaskInput Component
 * Reusable task input with autoComplete dropdown
 */
const TaskInput = ({
  taskName,
  setTaskName,
  setTaskError,
  filteredData,
  setFilteredData,
  groupedTimerData,
  dropdownVisible,
  handleInputClick,
  autoLoad,
  autoFillDropdownRef,
  className = "timer-input-sec",
  placeholder = "You're working on...",
  showAutocomplete = true,
}) => {
  return (
    <div className="project-name">
      <Col className="cursor" ref={autoFillDropdownRef}>
        <input
          type="text"
          value={taskName || ""}
          onChange={(e) => {
            setTaskName(e.target.value);
            if (setTaskError) setTaskError(false);
            const filterText = e.target.value.toLowerCase();
            const filteredItems = groupedTimerData.filter((item) =>
              item.task.toLowerCase().includes(filterText)
            );
            setFilteredData(filteredItems);
          }}
          onClick={handleInputClick}
          placeholder={placeholder}
          className={className}
          style={{ textOverflow: "ellipsis" }}
          autoComplete="off"
        />
        {showAutocomplete && filteredData.length > 0 && dropdownVisible && (
          <div className="dropdown">
            <ul>
              {filteredData.slice(0, 8).map((item) => (
                <li
                  key={item._id}
                  onClick={() => {
                    autoLoad(
                      item.task,
                      item.project?._id,
                      item.project?.project_name,
                      item.tag ? item.tag.tag_name : null,
                      item.tag ? item.tag._id : null,
                      item.client,
                      item.project?.client_name,
                      item.sprint ? item.sprint.sprint_name : null,
                      item.sprint ? item.sprint._id : null,
                      item._id,
                      item.billable
                    );
                  }}
                >
                  <div className="project-des">{item.task}</div>
                  <div className="project-sug-name">
                    {item.project?.project_name}{" "}
                    {`${item.sprint ? ` - ${item.sprint.sprint_name}` : ""}`}
                    <span className="project-tag-sug">{item.client}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Col>
    </div>
  );
};

export default TaskInput;

